import React, {memo} from "react";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import Divider from "./Divider";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledMainContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0px;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledScoreControlContainerDiv = styled.div`
  width: 64px;
`;

const StyledNodeSearchControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-left: 8px;
  > div {
    width: 100% !important;
    flex: 1 !important;
  }
`;

const DefaultVoiceAnswer = ({controls, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0 || isNodeCollapsed) return null;

    const defaultVoiceAnswerUUID = controls[0].key.split("_")[0];
    const searchControl = controls.find(control => control.key.includes(SequenceComponentHelper.getDefaultVoiceAnswerNodeSearchKey(defaultVoiceAnswerUUID)));
    const scoreControl = controls.find(control => control.key.includes(SequenceComponentHelper.getDefaultVoiceAnswerScoreKey(defaultVoiceAnswerUUID)));

    return (
        <>
            <StyledMainContainerDiv>

                {/** SCORE CONTROL */}
                <StyledScoreControlContainerDiv>
                    <Control key={scoreControl.key} control={scoreControl} innerRef={bindControl}/>
                </StyledScoreControlContainerDiv>

                {/** NODE SEARCH CONTROL */}
                <StyledNodeSearchControlContainerDiv>
                    <Control key={searchControl.key} control={searchControl} innerRef={bindControl}/>
                </StyledNodeSearchControlContainerDiv>
            </StyledMainContainerDiv>
            <Divider height={1}/>
        </>
    );
}

export default memo(DefaultVoiceAnswer)